(() => {
  if (window.ugSizeTooltipReady) return;
  window.ugSizeTooltipReady = true;
  let popup, timer;
  const hide = () => { if (popup) popup.hidden = true; clearTimeout(timer); };
  const show = (control, value) => {
    const picker = control.closest('variant-selects');
    if (!picker) return;
    const scope = picker.closest('product-info') || picker.closest('.product__info-container');
    const guide = scope && scope.querySelector('.ug-sizes--pdp');
    if (!guide || guide.dataset.ugSizeKind === 'mind') return hide();
    const group = control.closest('.product-form__input');
    const optionName = (control.dataset.optionName || (group && group.querySelector('legend, .form__label')?.textContent) || '').toLowerCase();
    if (!/size|velič|velic|broj|velik|talla|taille/.test(optionName)) return;
    let size = String(value).trim().replace(',', '.').replace(/^EU\s*/i, '');
    if (guide.dataset.ugSizeKind === 'nb') size = ({'39':'39.5','41':'41.5','47':'47.5'})[size] || size;
    const row = Array.from(guide.querySelectorAll('[data-ug-eu]')).find(item => item.dataset.ugEu === size);
    if (!row) return hide();
    if (!popup) {
      popup = document.createElement('div');
      popup.className = 'ug-size-tooltip';
      popup.setAttribute('role', 'status');
      popup.setAttribute('aria-live', 'polite');
      document.body.appendChild(popup);
    }
    const anchor = control.matches('input') ? document.querySelector('label[for="' + CSS.escape(control.id) + '"]') || control : control;
    popup.textContent = 'EU ' + size.replace('.', ',') + ' · ' + guide.dataset.ugSizeLabel + ': ' + row.dataset.ugCm.replace('.', ',') + ' cm';
    popup.hidden = false;
    const box = anchor.getBoundingClientRect();
    const width = popup.offsetWidth, height = popup.offsetHeight;
    popup.style.left = Math.max(8, Math.min(window.innerWidth - width - 8, box.left + box.width / 2 - width / 2)) + 'px';
    popup.style.top = Math.max(8, box.top > height + 16 ? box.top - height - 8 : Math.min(window.innerHeight - height - 8, box.bottom + 8)) + 'px';
    clearTimeout(timer);
    timer = setTimeout(hide, 4000);
  };
  document.addEventListener('click', event => {
    const label = event.target.closest('variant-selects label[for]');
    if (label) {
      const input = document.getElementById(label.htmlFor);
      if (input && input.type === 'radio' && !input.disabled) show(input, input.value);
    } else if (!event.target.closest('.ug-size-tooltip, variant-selects')) hide();
  });
  document.addEventListener('change', event => {
    const control = event.target;
    if (!control.closest('variant-selects')) return;
    if (control.matches('input[type="radio"]')) show(control, control.value);
    if (control.matches('select')) show(control, control.value);
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); });
  window.addEventListener('scroll', hide, { passive: true });
  window.addEventListener('resize', hide);
})();
